import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';


const bankOne = [{
  keyCode: 81,
  keyTrigger: 'Q',
  id: 'Heater-1',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3'
}, {
  keyCode: 87,
  keyTrigger: 'W',
  id: 'Heater-2',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3'
}, {
  keyCode: 69,
  keyTrigger: 'E',
  id: 'Heater-3',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3'
}, {
  keyCode: 65,
  keyTrigger: 'A',
  id: 'Heater-4',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3'
}, {
  keyCode: 83,
  keyTrigger: 'S',
  id: 'Clap',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3'
}, {
  keyCode: 68,
  keyTrigger: 'D',
  id: 'Open-HH',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3'
}, {
  keyCode: 90,
  keyTrigger: 'Z',
  id: "Kick-n'-Hat",
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3'
}, {
  keyCode: 88,
  keyTrigger: 'X',
  id: 'Kick',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3'
}, {
  keyCode: 67,
  keyTrigger: 'C',
  id: 'Closed-HH',
  url: 'https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3'
},
];

const bankTwo = [{
keyCode: 81,
keyTrigger: 'Q',
id: 'Chord-1',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3'
}, {
keyCode: 87,
keyTrigger: 'W',
id: 'Chord-2',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3'
}, {
keyCode: 69,
keyTrigger: 'E',
id: 'Chord-3',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3'
}, {
keyCode: 65,
keyTrigger: 'A',
id: 'Shaker',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3'
}, {
keyCode: 83,
keyTrigger: 'S',
id: 'Open-HH',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3'
}, {
keyCode: 68,
keyTrigger: 'D',
id: 'Closed-HH',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3'
}, {
keyCode: 90,
keyTrigger: 'Z',
id: 'Punchy-Kick',
url: 'https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3'
}, {
keyCode: 88,
keyTrigger: 'X',
id: 'Side-Stick',
url: 'https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3'
}, {
keyCode: 67,
keyTrigger: 'C',
id: 'Snare',
url: 'https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3'
}];

const APColor = '#DBFF76';
const IPColor = '#4A4242';
const activePad = {
backgroundColor: APColor,
boxShadow: "0 3px grey",
}


const inactivePad = {
backgroundColor: IPColor,  
boxShadow: "3px 3px 5px black",
}


class DrumPad extends React.Component{
constructor(props){
  super(props);
  this.state = {
    padStyle: inactivePad
  }    
  this.playSound = this.playSound.bind(this);
  this.handleKeyPress = this.handleKeyPress.bind(this);
  this.activatePad = this.activatePad.bind(this); 
}
  componentDidMount() {
  document.addEventListener('keydown', this.handleKeyPress);
}
componentWillUnmount() {document.removeEventListener('keydown', this.handleKeyPress);
}
handleKeyPress(e) {
  if (e.keyCode === this.props.keyCode) {
    this.playSound();
  }
}

activatePad() {
  console.log("activating pad")

if (this.props.power) {
this.state.padStyle.backgroundColor === APColor ?
  this.setState({
    padStyle: inactivePad
  }) :
  this.setState({
    padStyle: activePad
  });
} 

else {
this.state.padStyle.boxShadow === '0 3px grey' ?
  this.setState({
    padStyle: inactivePad
  }) :
  this.setState({
    padStyle: {
    backgroundColor: IPColor,
    boxShadow: "0 3px grey"
    }
  });
}
}

playSound(e) {
  
  const sound = document.getElementById(this.props.keyTrigger);
  sound.currentTime = 0;
  sound.play();
  //console.log("soundsoundsound " + this.props.keyTrigger)
  this.activatePad();
  setTimeout(() => this.activatePad(), 100);
  this.props.updateDisplay(this.props.clipId.replace(/-/g, ' '));
}

  
  render() {
  return (
    <div id={this.props.clipId} 
      onClick={this.playSound} 
      className="drum-pad"
      style={this.state.padStyle}
       >
        <audio className='clip' id={this.props.keyTrigger} src={this.props.clip}></audio>
      <p className = "padText">{this.props.keyTrigger}</p>
    </div>
  )
}
}

///--------------------------------------------------------------------------------------------------------------------------------
class PadBank extends React.Component {

render() {
  let padBank;
  this.props.power ?
    padBank = this.props.currentPadBank.map((drumObj, i, padBankArr) => {
      return (
        <DrumPad 
          key = {i}
          clipId={padBankArr[i].id} 
          clip={padBankArr[i].url}
          keyTrigger={padBankArr[i].keyTrigger}
          keyCode={padBankArr[i].keyCode} 
          updateDisplay={this.props.updateDisplay} 
          power={this.props.power} />
      )
    }) :
    padBank = this.props.currentPadBank.map((drumObj, i, padBankArr) => {
      return (
        <DrumPad 
          clipId={padBankArr[i].id} 
          clip="#"
          keyTrigger={padBankArr[i].keyTrigger}
          keyCode={padBankArr[i].keyCode} 
          updateDisplay={this.props.updateDisplay} 
          power={this.props.power} />
      )
    });
  return (
    <div className="pad-bank" >
      {padBank}
    </div>
  )
}
}
////-----------------------------------------------------------------------------  
class App extends React.Component{
  constructor(props){
super(props);
    this.state= {
      power: true,
      display: String.fromCharCode(160),
      currentPadBank: bankOne,
      currentPadBankId: 'Heater Kit',
      sliderVal: 1      
    }
        this.displayClipName = this.displayClipName.bind(this);
        this.selectBank = this.selectBank.bind(this);
        this.adjustVolume = this.adjustVolume.bind(this);
        this.powerControl = this.powerControl.bind(this);
        this.clearDisplay = this.clearDisplay.bind(this);
  }
  
powerControl() {
  this.setState({
    power: !this.state.power,
    display: !this.state.power ? "power on":"power off"
  });
      setTimeout(() => this.clearDisplay(), 1000);

}

  displayClipName(name) {
    if (this.state.power) {
      this.setState({
        display: name
      });
    }
    //setTimeout(() => this.clearDisplay(), 1000);
  }
  
adjustVolume(e) {
  if (this.state.power) {
    this.setState({
      sliderVal: e.target.value,
      display: "Volume: " + Math.round(e.target.value * 100)
    });
    setTimeout(() => this.clearDisplay(), 1000);
  }
}

clearDisplay() {
  this.setState({
    display: String.fromCharCode(160)
  });
}



selectBank() {
  if (this.state.power) {
    this.state.currentPadBankId === 'Heater Kit' ?
      this.setState({
        currentPadBank: bankTwo,
        display: 'Smooth Piano Kit',
        currentPadBankId: 'Smooth Piano Kit',
      }) :
      this.setState({
        currentPadBank: bankOne,
        display: 'Heater Kit',
        currentPadBankId: 'Heater Kit',
      });
  }
}

///get placeholder to be affected by function
render(){ 
  {
    const clips = [].slice.call(document.getElementsByClassName('clip'));
    clips.forEach(sound => {
      sound.volume = this.state.sliderVal
    });
  }
  return(
    <div id = "container">
  <div className = "t"><h1> ReactJs Drum Machine</h1></div>  
  <div id = "drum-machine">  
      <div className="controls-container">        
          <div class = "displayContainer">
            <p id="display">						{this.state.display}</p>
          </div>   	  
       <div className="control">				
        <div className="control">	            
          <button onClick={this.selectBank} className="controlButton" alt = "Bank selection">
            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20.5" cy="20.5" r="19" fill="#373737"/>
<circle cx="20.5" cy="20.5" r="19" stroke="#0C0C0C" stroke-width="3"/>
<circle cx="20.5" cy="20.5" r="19" stroke="url(#paint0_linear)" stroke-width="3"/>
<line x1="14.5789" y1="28.2679" x2="25.059" y2="14.8826" stroke="white" stroke-width="3"/>
<defs>
<linearGradient id="paint0_linear" x1="20.5" y1="0" x2="20.5" y2="41" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>

          </button>
          <button onClick={this.powerControl} className="controlButton" alt = "Power"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20.5" cy="20.5" r="19" fill="black"/>
<circle cx="20.5" cy="20.5" r="19" stroke="#0C0C0C" stroke-width="3"/>
<circle cx="20.5" cy="20.5" r="19" stroke="url(#paint0_linear)" stroke-width="3"/>
<path d="M26.8139 14.8334C30.1222 18.1417 30.1222 23.5055 26.8139 26.8138C23.5055 30.1222 18.1417 30.1222 14.8334 26.8138C11.5251 23.5055 11.5251 18.1417 14.8334 14.8334" stroke="white" stroke-width="3"/>
<line x1="20.2059" y1="21.5667" x2="20.2059" y2="9.9742" stroke="white" stroke-width="3"/>
<defs>
<linearGradient id="paint0_linear" x1="20.5" y1="0" x2="20.5" y2="41" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>





          </button>
          <div className="volume-slider">
          <input type="range" min="0" max="1" step="0.01" value={this.state.sliderVal} onChange={this.adjustVolume} />
        </div>
         </div>
        </div>
      </div>
   
      <PadBank power={this.state.power}
        clipVolume={this.state.sliderVal}
        currentPadBank={this.state.currentPadBank}
        updateDisplay = {this.displayClipName}/>
        <div  className = "logo">
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<line y1="-0.5" x2="9.87243" y2="-0.5" transform="matrix(0.831106 0.629071 -0.641249 0.706489 14.5424 4.78619)" stroke="#F4F7BE"/>
<g filter="url(#filter0_d)">
<path d="M15.789 12.154C13.6482 12.0812 11.7132 11.6497 10.3203 11.0303C9.62285 10.7202 9.08534 10.3736 8.72504 10.0222C8.36678 9.67275 8.2116 9.34843 8.19536 9.05878C8.17911 8.76914 8.29843 8.45414 8.61879 8.12777C8.94096 7.79956 9.44156 7.48822 10.1068 7.22439C11.4354 6.6975 13.3293 6.39613 15.4701 6.46888C17.6108 6.54163 19.5459 6.97313 20.9388 7.59251C21.6362 7.90265 22.1737 8.24926 22.534 8.60067C22.8923 8.9501 23.0475 9.27443 23.0637 9.56407C23.08 9.85372 22.9606 10.1687 22.6403 10.4951C22.3181 10.8233 21.8175 11.1346 21.1522 11.3985C19.8237 11.9254 17.9297 12.2267 15.789 12.154Z" stroke="#F4F7BE"/>
</g>
<line y1="-0.5" x2="10.9608" y2="-0.5" transform="matrix(-0.605241 0.738209 -0.683947 -0.787828 15.2091 16.631)" stroke="#F4F7BE"/>
<line y1="-0.5" x2="22.104" y2="-0.5" transform="matrix(-0.623184 0.722738 -0.829481 -0.631325 22.7421 11.007)" stroke="#F4F7BE"/>
<rect x="-0.224664" y="0.229676" width="22.912" height="0.476277" transform="matrix(0.0560029 0.998431 -0.999423 -0.0339648 14.5949 5.26841)" stroke="#F4F7BE" stroke-width="0.476277"/>
<path d="M16.5294 16.6407C15.5022 16.6058 14.4743 15.555 14.3935 14.1142C14.3127 12.6734 15.2264 11.6886 16.2536 11.7235C17.2808 11.7584 18.3087 12.8092 18.3895 14.25C18.4703 15.6908 17.5566 16.6756 16.5294 16.6407Z" stroke="#F4F7BE"/>
<path d="M16.0091 12.0705C16.4072 11.8687 16.8674 12.0803 16.9798 12.5168C17.1897 13.3319 16.1312 13.8685 15.6956 13.1679C15.4624 12.7926 15.611 12.2723 16.0091 12.0705Z" stroke="#F4F7BE"/>
<line x1="20.3686" y1="7.38307" x2="14.3962" y2="5.25159" stroke="#F4F7BE"/>
<line y1="-0.5" x2="2.28438" y2="-0.5" transform="matrix(0.177821 0.984063 -0.99772 0.067495 8.57001 24.7441)" stroke="#F4F7BE"/>
<defs>
<filter id="filter0_d" x="3.69339" y="5.95863" width="23.8723" height="14.7056" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
</svg>

</div> 
</div> 
<div className = "signature"><h4><a href = "https://alecesana.github.io">Alessandro Cesana</a></h4>
    
</div>
      
      

      </div>
    
  );  
}
}



 


ReactDOM.render(<App/>, document.getElementById("root"))



export default App;
